document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('vsNewsletterTrigger');
  const modal = document.getElementById('vsNewsletterModal');
  const overlay = document.getElementById('vsNewsletterOverlay');
  const close = document.getElementById('vsNewsletterClose');
  const floatingClose = document.getElementById('vsNewsletterFloatingClose');

  const productImg = document.getElementById('vsNewsletterProductImg');
  const productLink = document.getElementById('vsNewsletterProductLink');
  const productTitle = document.getElementById('vsNewsletterProductTitle');
  const productPrice = document.getElementById('vsNewsletterProductPrice');
  const productsScript = document.getElementById('vsNewsletterProducts');

  const FALLBACK_PRODUCTS = [
    {
      title: 'Air Jordan 1 Low x Travis Scott Fragment',
      url: '/products/air-jordan-1-low-x-travis-scott-fragment-dunk-low-shoes',
      image: 'https://thevinescape.com/cdn/shop/files/D52F4B92-E1FD-45D0-AB7B-B04A1061213B_edfacc52-2aae-4f87-9c4a-05e8e598f596.png?v=1784377064&width=800',
      price: '₹14,999.00'
    },
    {
      title: 'Dior B23 High-Top Oblique Sneakers',
      url: '/products/dior-b23-high-top-oblique-sneakers',
      image: 'https://thevinescape.com/cdn/shop/files/D522D55C-A1CA-45FC-A927-69BE4536538B_e0a949e5-763b-4839-9f6d-f00f1e6c4c88.png?v=1784377074&width=800',
      price: '₹18,500.00'
    },
    {
      title: 'Fendi Roma FF Monogram Logo T-Shirt',
      url: '/products/fendi-roma-ff-monogram-logo-t-shirt',
      image: 'https://thevinescape.com/cdn/shop/files/5566086F-6AE3-4E26-95BF-98803CA18519.png?v=1784377073&width=800',
      price: '₹7,999.00'
    },
    {
      title: 'BOSS Signature Tipped Polo Shirt',
      url: '/products/boss-signature-tipped-polo-shirt',
      image: 'https://thevinescape.com/cdn/shop/files/DDFBCC34-FC9E-41DE-842F-3D79407B370B.png?v=1784377072&width=800',
      price: '₹6,499.00'
    }
  ];

  function getProductsList() {
    if (productsScript && productsScript.textContent.trim()) {
      try {
        const parsed = JSON.parse(productsScript.textContent.trim());
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      } catch (err) {
        console.warn('[VS Newsletter] Could not parse products JSON script:', err);
      }
    }
    return FALLBACK_PRODUCTS;
  }

  function pickRandomProduct() {
    const products = getProductsList();
    if (!products || products.length === 0) return;
    const item = products[Math.floor(Math.random() * products.length)];

    if (productImg && item.image) {
      productImg.src = item.image;
      productImg.alt = item.title || 'Featured Product';
    }
    if (productLink && item.url) {
      productLink.href = item.url;
    }
    if (productTitle && item.title) {
      productTitle.textContent = item.title;
    }
    if (productPrice) {
      productPrice.textContent = item.price || '';
    }
  }

  function hideFloating() {
    if (trigger) {
      trigger.classList.add('is-hidden');
    }
  }

  function openModal() {
    if (!modal || !overlay) return;
    pickRandomProduct();
    modal.classList.add('active');
    overlay.classList.add('active');
    hideFloating();
  }

  function closeModal() {
    if (!modal || !overlay) return;
    modal.classList.remove('active');
    overlay.classList.remove('active');
  }

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      if (e.target.closest('.vs-newsletter-floating__close')) return;
      openModal();
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.target.closest('.vs-newsletter-floating__close')) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal();
      }
    });
  }

  if (floatingClose) {
    floatingClose.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hideFloating();
    });
  }

  if (close) {
    close.addEventListener('click', closeModal);
  }

  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('active')) {
      closeModal();
    }
  });

  // Shopify stores the phone in E.164, so send +91 plus the 10 typed digits
  const phoneInput = document.getElementById('vsNewsletterPhone');
  const phoneFull = document.getElementById('vsNewsletterPhoneFull');
  if (phoneInput && phoneFull && phoneInput.form) {
    phoneInput.form.addEventListener('submit', function () {
      phoneFull.value = '+91' + phoneInput.value.trim();
    });
  }

  // Pick an initial random product ready in background
  pickRandomProduct();

  // ── Auto-open after 12s if user hasn't seen it before ──
  const SEEN_KEY = 'vs_newsletter_seen';

  function markSeen() {
    try { localStorage.setItem(SEEN_KEY, '1'); } catch (_) {}
  }

  function hasSeen() {
    try { return localStorage.getItem(SEEN_KEY) === '1'; } catch (_) { return false; }
  }

  // Mark as seen whenever the modal is closed or form submitted
  if (close) {
    close.addEventListener('click', markSeen);
  }
  if (overlay) {
    overlay.addEventListener('click', markSeen);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('active')) markSeen();
  });
  const joinForm = document.querySelector('#vsNewsletterModal form');
  if (joinForm) {
    joinForm.addEventListener('submit', markSeen);
  }

  // Auto-open after 12 seconds if not seen
  if (!hasSeen()) {
    setTimeout(function () {
      if (!modal.classList.contains('active')) {
        openModal();
        markSeen();
      }
    }, 12000);
  }
});
